import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import '../../styles/main.scss';
import '../../styles/_normalize.scss';
// import { connect } from 'react-redux'
import { welcome } from '../../actions'

const App = () => (
  <BrowserRouter>
    <div className="App">
      <Layout />
    </div>
  </BrowserRouter>
);

// const mapStateToProps = state => ({
//   text: state.dummy.text
// })

// const mapDispatchToProps = (dispatch, ownProps) => ({
//   onClick: () => dispatch(welcome('Well done 👍'))
// })

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(App)
export default App;
